import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'RiskAssessment',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RiskAssessment',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RiskAssessment',
    column_type: 'datetime',
  },
  name: {
    model_name: 'RiskAssessment',
    column_type: 'string',
  },
  kind: {
    model_name: 'RiskAssessment',
    column_type: 'enum',
  },
  state: {
    model_name: 'RiskAssessment',
    column_type: 'enum',
  },
  risk_assessment_questions: {
    model_name: 'RiskAssessment',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_questions',
      model_name: 'RiskAssessmentQuestion',
      foreign_key: 'risk_assessment_id',
    },
  },
  risk_assessment_question_ids: {
    model_name: 'RiskAssessment',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_questions',
      model_name: 'RiskAssessmentQuestion',
      foreign_key: 'risk_assessment_id',
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
